export const USERS = 'users';
export const USER = 'user';
export const TASKS = 'tasks';
export const CATEGORIES = 'categories';
export const CONTENTS = 'contents';
export const VIDEOS = 'videos';
export const NOTIFICATIONS = 'notificationsHistory';
export const PRODUCTS = 'products';
export const PLANS = 'plans';
export const COURSES = 'courses';
export const PRODUCT_CATEGORIES = 'productCategories';
